import React from 'react';
import { Row, Col, Form, Button, Spinner, Modal } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { DollarCurrency, EuroCurrency, Currency } from 'helpers/Currency';
import Input from 'helpers/Input';

export function InvoiceModal({
  showModal,
  handleHideModal,
  t,
  currency,
  currencies,
  setCurrency,
  isInvoice,
  value,
  setValue,
  dueDate,
  setDueDate,
  isLoading,
  handleSave,
  setNumber,
  setPostalCode,
  setTerms,
  setStateRegistration,
  number,
  postalCode,
  terms,
  stateRegistration,
  error,
  description, setDescription,
  actionName
}) {
  return (
    <Modal size="lg" show={showModal} onHide={handleHideModal}>
      <Modal.Body>
        <Row>
          {isInvoice && (
            <Col>
              <Form.Group>
                <Form.Label>{t('label:currency')}</Form.Label>
                <Form.Control
                  as="select"
                  value={currency}
                  onChange={(e) => setCurrency(e.target.value)}
                  required
                  disabled={!isInvoice}
                >
                  <option disabled value="">
                    {t('label:select')}
                  </option>
                  {currencies
                    .filter((currency) => currency.name !== 'Real')
                    .map((currency, k) => (
                      <option key={k} value={currency.id}>
                        {t(`label:${currency.name}`)}
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>
            </Col>
          )}
          {currency === '2' && (
            <Col>
              <Form.Group>
                <Form.Label>{t('label:value')}</Form.Label>
                <DollarCurrency
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value);
                  }}
                  required
                />
              </Form.Group>
            </Col>
          )}

          {!currency && (
            <Col>
              <Form.Group>
                <Form.Label>{t('label:value')}</Form.Label>
                <Currency
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value);
                  }}
                  required
                />
              </Form.Group>
            </Col>
          )}

          {currency === '3' && (
            <Col>
              <Form.Group>
                <Form.Label>{t('label:value')}</Form.Label>
                <EuroCurrency
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value);
                  }}
                  required
                />
              </Form.Group>
            </Col>
          )}
          <Col>
            <Form.Group>
              <Form.Label>{t('label:expiry')}</Form.Label>
              <DatePicker
                className="form-control"
                dateFormat="dd/MM/yyyy"
                locale="pt_BR"
                selected={dueDate}
                required
                onChange={(date) => {
                  setDueDate(date);
                }}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          {isInvoice && (
            <Col>
              <Form.Group>
                <Form.Label>{t('label:Pay Terms')}</Form.Label>
                <Form.Control
                  value={terms}
                  onChange={(e) => {
                    setTerms(e.target.value);
                  }}
                  required
                ></Form.Control>
              </Form.Group>
            </Col>
          )}
          <Col>
            <Form.Group>
              <Form.Label>{t('label:number')}</Form.Label>
              <Form.Control
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                required
              ></Form.Control>
            </Form.Group>
          </Col>
          {!isInvoice && (
            <Col>
              <Form.Group>
                <Form.Label>{t('label:Postal Code')}</Form.Label>
                <Input.CEP
                  value={postalCode}
                  onChange={(e) => setPostalCode(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          )}

          {!isInvoice && (
            <Col>
              <Form.Group>
                <Form.Label>{t('label:State Registration')}</Form.Label>
                <Input.stateRegistration
                  value={stateRegistration}
                  onChange={(e) => setStateRegistration(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          )}
          <Col xs="12">
            <Form.Group>
              <Form.Label>Descrição</Form.Label>
              <Form.Control
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
                placeholder={actionName}
              ></Form.Control>
            </Form.Group>
          </Col>
        </Row>
        {isLoading && (
          <Row className="justify-content-center align-items-center">
            <Spinner animation="border" style={{ color: '#e05c17' }} role="status" >
              <span className="sr-only">Loading...</span>
            </Spinner>{' '}
            <span>{t('label:Generating PDF')}...</span>
          </Row>
        )}
        {error && (
          <Row className="justify-content-center align-items-center">
            <span>{t('error:Error')}</span>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button size="sm" variant="danger" onClick={handleHideModal}>
          {t('label:cancel')}
        </Button>
        <Button size="sm" onClick={() => handleSave()} disabled={isLoading}>
          {t('label:save')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
